/**
 * Historial de vistas del reporte.
 */
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// El registro de ChartJS debe ir afuera del componente (ya está bien)
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const ReportViewsModal = ({ show, onClose, reportViews, users, findUserName, styles }) => {
    
    // Si el modal está oculto, no renderiza nada
    if (!show) return null;

    const processTimeSeriesData = (timeSeries) => {
        if (!timeSeries || timeSeries.length === 0) {
            return { labels: [], datasets: [] };
        }

        const viewsByDay = timeSeries.reduce((acc, view) => {
            if (view && view.viewedAt && view.viewedAt._seconds) {
                const date = new Date(view.viewedAt._seconds * 1000).toLocaleDateString('es-ES', { 
                    year: '2-digit', 
                    month: '2-digit', 
                    day: '2-digit' 
                });
                acc[date] = (acc[date] || 0) + 1;
            }
            return acc;
        }, {});

        const labels = Object.keys(viewsByDay);
        const data = Object.values(viewsByDay);

        return {
            labels,
            datasets: [
                {
                    label: 'Vistas por Día',
                    data: data,
                    fill: false,
                    backgroundColor: 'rgba(94, 53, 177, 0.2)',
                    borderColor: '#5E35B1',
                    tension: 0.1,
                },
            ],
        };
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: { display: false },
        },
    };

    return (
        <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
                <h3 style={{color:'#5E35B1'}}>Desglose de Vistas: {reportViews?.reportName || ''}</h3>
                {reportViews && reportViews.views && reportViews.views.length > 0 ? (
                    <>
                    <div style={{marginBottom: '30px'}}>
                        <h4>Evolución de Vistas</h4>
                        <Line options={chartOptions} data={processTimeSeriesData(reportViews.timeSeries)} />
                    </div>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}></th>
                                <th style={styles.th}>Usuario</th>
                                <th style={styles.th}>Vistas</th>
                                <th style={styles.th}>Última Vista</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportViews.views.map(view => (
                                <tr key={view.userId} style={styles.tr}>
                                    <td>
                                        <img 
                                            src={users.find(u => u.uid === view.userId)?.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(findUserName(view.userId))}&background=5E35B1&color=fff&size=30`} 
                                            alt="Perfil" 
                                            style={styles.miniProfileImage} 
                                            referrerPolicy="no-referrer" 
                                        />
                                    </td>
                                    <td>{findUserName(view.userId)}</td>
                                    <td>{view.count}</td>
                                    <td>{view.lastViewed && view.lastViewed._seconds ? new Date(view.lastViewed._seconds * 1000).toLocaleString() : 'N/A'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </>
                ) : (
                    <p>Este reporte aún no tiene vistas registradas por usuario.</p>
                )}
                <button onClick={onClose} style={{...styles.btnGray, gridColumn: 'span 1', marginTop: '20px'}}>Cerrar</button>
            </div>
        </div>
    );
};

export default ReportViewsModal;